import React from 'react';

export type Props = {};

const Book2: React.FC<Props> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.48 3.46876C7.78641 2.66017 5.41922 2.26408 2.25 2.25001C1.95111 2.24595 1.65809 2.33311 1.41 2.49986C1.20637 2.6375 1.03968 2.82306 0.924597 3.04024C0.809512 3.25741 0.749555 3.49954 0.750002 3.74533V17.1563C0.750002 18.0628 1.395 18.7467 2.25 18.7467C5.58141 18.7467 8.92313 19.058 10.9247 20.9499C10.9521 20.9759 10.9865 20.9932 11.0237 20.9998C11.0608 21.0064 11.0991 21.002 11.1338 20.987C11.1685 20.972 11.1979 20.9472 11.2186 20.9156C11.2393 20.884 11.2502 20.847 11.25 20.8092V5.0072C11.2501 4.90059 11.2273 4.7952 11.1831 4.69816C11.139 4.60111 11.0745 4.51468 10.9941 4.4447C10.5356 4.05275 10.0263 3.72447 9.48 3.46876Z"
        fill="#62339C"
      />
      <path
        d="M22.59 2.49843C22.3418 2.33209 22.0488 2.24542 21.75 2.24999C18.5808 2.26405 16.2136 2.65827 14.52 3.46874C13.9737 3.72398 13.4643 4.05161 13.0055 4.4428C12.9252 4.5129 12.8609 4.59937 12.8168 4.69639C12.7728 4.79341 12.75 4.89874 12.75 5.0053V20.8083C12.75 20.8446 12.7607 20.88 12.7807 20.9103C12.8008 20.9405 12.8293 20.9641 12.8628 20.9782C12.8962 20.9923 12.9331 20.9961 12.9687 20.9893C13.0044 20.9825 13.0372 20.9654 13.0631 20.94C14.2664 19.7447 16.3781 18.7453 21.7519 18.7458C22.1497 18.7458 22.5312 18.5877 22.8125 18.3064C23.0938 18.0251 23.2519 17.6436 23.2519 17.2458V3.74577C23.2524 3.4995 23.1923 3.25688 23.0769 3.03934C22.9615 2.8218 22.7942 2.63603 22.59 2.49843Z"
        fill="#62339C"
      />
    </svg>
  );
};

export default Book2;
